import type { ComponentProps } from "react";
import { createNavigation } from "next-intl/navigation";
import { routing } from "./routing";

// Locale-aware navigation helpers. Use these instead of next/link &
// next/navigation so the active language is preserved across pages.
const nav = createNavigation(routing);
export const { redirect, usePathname, useRouter, getPathname } = nav;

type LinkProps = ComponentProps<typeof nav.Link>;

/**
 * `Link` with prefetching OFF by default.
 *
 * Next prefetches every <Link> that enters the viewport. Almost every page in
 * this app is dynamic, authenticated or database-backed, and for dynamic
 * routes a prefetch only fetches the loading shell — the data is not even
 * included — so the browser gets no faster navigation while the server does
 * real work. Measured on production: one admin page view fired 48 prefetch
 * requests in 6 seconds (every tab, nav and footer link, repeated per router
 * state). On the shared host that alone exhausted the entry-process limit
 * whenever requests were slow, and each queued request cost a cold start.
 *
 * Navigation feel is unaffected: the app already shows its own skeleton and
 * progress bar on click. A link that genuinely benefits (a static, public
 * page) can pass `prefetch` explicitly to opt back in.
 */
export function Link(props: LinkProps) {
  return <nav.Link prefetch={false} {...props} />;
}
